module.exports = __webpack_public_path__ + "static/media/Mobal_Logo_Transparent symbol_Black.bf404ac3.svg";